import { render, staticRenderFns } from "./ArchivePopup.vue?vue&type=template&id=7bfe063c&"
import script from "./ArchivePopup.vue?vue&type=script&lang=js&"
export * from "./ArchivePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports